import type { TCity } from "@/types"

export const cityName = ({ name, name_local }: Pick<TCity, "name" | "name_local">, locale: string = "en") =>
  locale === "en" ? name : name_local
